type productType = 'apps' | 'admin';

/**
 * pathName 기준으로 프로덕트 타입 분류
 */
export default function getProductType(pathName?: string): productType | null {
  if (!pathName) {
    return null;
  }

  const rootPathName = pathName.split('/')[1];
  let productType: productType = 'apps';

  switch (rootPathName) {
    case '':
      productType = 'apps';
      break;
    case 'admin':
      productType = 'admin';
      break;
  }

  return productType;
}
